import { ApiFetchError } from '@/hooks/api-fetcher'

export type PlanChangeNoticeKey =
  | 'planChangeDuringFreePeriod'
  | 'planChangeWhilePastDue'
  | 'planChangeFailed'

/**
 * Which message to show when an in-place plan change fails. A subscription in
 * a free period granted by Soku refuses plan changes until the period ends;
 * the generic "please try again" would send the customer round in circles.
 * Same for a subscription whose renewal charge failed: it is refused until the
 * open invoice is paid, which no amount of retrying gets around.
 */
export function planChangeNoticeKey(error: unknown): PlanChangeNoticeKey {
  if (!(error instanceof ApiFetchError)) return 'planChangeFailed'
  if (error.code === 'plan_change_during_free_period') {
    return 'planChangeDuringFreePeriod'
  }
  if (error.code === 'subscription_past_due') return 'planChangeWhilePastDue'
  return 'planChangeFailed'
}
